import type { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgIconTryFilledSmall = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="none" viewBox="0 0 32 32" aria-hidden={!title && !titleId} aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<path fill="currentColor" fillRule="evenodd" d="M9.139 5.666A2.2 2.2 0 0 1 10.714 5h10.572a2.2 2.2 0 0 1 1.575.665l6.505 6.67c.85.87.844 2.27-.013 3.133l-11.791 11.88c-.863.87-2.261.87-3.124 0L2.647 15.468a2.237 2.237 0 0 1-.013-3.134zm3.113 4.7c.37.373.37.977 0 1.35l-2.17 2.186 2.17 2.187c.37.373.37.976 0 1.349a.94.94 0 0 1-1.339 0l-2.84-2.862a.96.96 0 0 1 0-1.348l2.84-2.862a.94.94 0 0 1 1.339 0" clipRule="evenodd" /></svg>;
export default SvgIconTryFilledSmall;